import { IEscrowExpectedIncomingCheckData } from '../../types/accounting/data/IEscrowExpectedIncomingCheckData';
import { IEscrowExpectedIncomingWireData } from '../../types/accounting/data/IEscrowExpectedIncomingWireData';
import { IEscrowExpectedIncomingAchData } from '../../types/accounting/data/IEscrowExpectedIncomingAchData';

export const calculateRemainingSplitValue = <
  T extends IEscrowExpectedIncomingCheckData | IEscrowExpectedIncomingWireData | IEscrowExpectedIncomingAchData
>(
  startingAmount: number,
  matches: T[]
) => startingAmount - matches.reduce((p, c) => p + c.amountCents, 0);
